/**
 * Prepared drops that are SENT, have sentDropId, and executeAfter is still in the future.
 */

import type { PreparedDrop } from '@/features/smswiser-campaigns/types/workspace.types';

export function isScheduledSentPrepared(d: PreparedDrop, nowMs: number = Date.now()): boolean {
  if (d.status !== 'SENT' || d.sentDropId == null) return false;
  const raw = d.executeAfter?.trim();
  if (!raw) return false;
  const t = new Date(raw).getTime();
  if (Number.isNaN(t)) return false;
  return t > nowMs;
}

export function getPropagationScheduledSentIds(
  propagateToCountries: string[],
  selectedIds: string[],
  drops: PreparedDrop[],
): string[] {
  if (propagateToCountries.length === 0) return [];
  const selected = new Set(selectedIds);
  const tagNames = new Set<string>();
  for (const d of drops) {
    if (selected.has(d.id) && d.staticTag?.name) tagNames.add(d.staticTag.name);
  }
  if (tagNames.size === 0) return [];
  const ckSet = new Set(propagateToCountries);
  return drops
    .filter(
      (d) =>
        isScheduledSentPrepared(d) &&
        ckSet.has(d.countryKey) &&
        d.staticTag?.name != null &&
        tagNames.has(d.staticTag.name),
    )
    .map((d) => d.id);
}

export function mergeBulkEditScheduledSentIds(
  selectedIds: string[],
  propagateToCountries: string[],
  drops: PreparedDrop[],
): string[] {
  const propagated = getPropagationScheduledSentIds(propagateToCountries, selectedIds, drops);
  return [...new Set([...selectedIds, ...propagated])];
}

export function countAffectedScheduledSentEdits(
  selectedIds: string[],
  propagateToCountries: string[],
  drops: PreparedDrop[],
): number {
  return mergeBulkEditScheduledSentIds(selectedIds, propagateToCountries, drops).length;
}
